"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _styledSystem = require("styled-system");

var _custom = _interopRequireDefault(require("../custom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _styledComponents.css)(["", " ", ";"], (0, _styledSystem.compose)(_styledSystem.background, _styledSystem.border, _styledSystem.color, _styledSystem.flexbox, _styledSystem.grid, _styledSystem.layout, _styledSystem.position, _styledSystem.shadow, _styledSystem.space, _styledSystem.typography), _custom["default"]);

exports["default"] = _default;